var _style, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPlaystoreBtnBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "artwork",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134.8 40.3",
    style: {
      enableBackground: "new 0 0 134.8 40.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.65;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{opacity:0.2;enable-background:new    ;}\r\n\t.st6{opacity:0.12;enable-background:new    ;}\r\n\t.st7{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st8{stroke:#FFFFFF;stroke-width:0.2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.1,0.9c2.3,0,4.2,1.9,4.2,4.2v30c0,2.3-1.9,4.2-4.2,4.2H5.1c-2.3,0-4.2-1.9-4.2-4.2v-30c0-2.3,1.9-4.2,4.2-4.2 L130.1,0.9 M130.1,0.1H5.1c-2.8,0-5,2.3-5,5v30c0,2.8,2.3,5,5,5h125c2.8,0,5-2.3,5-5v-30C135.1,2.4,132.9,0.1,130.1,0.1L130.1,0.1 z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3,21.9c-2.4,0-4.3,1.8-4.3,4.3c0,2.4,1.9,4.3,4.3,4.3s4.3-1.8,4.3-4.3C72.5,23.7,70.6,21.9,68.3,21.9z M68.3,28.7 c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6s2.4,1,2.4,2.6C70.7,27.6,69.5,28.7,68.3,28.7z M58.9,21.9c-2.4,0-4.3,1.8-4.3,4.3 c0,2.4,1.9,4.3,4.3,4.3c2.4,0,4.3-1.8,4.3-4.3S61.3,21.9,58.9,21.9z M58.9,28.7c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6 c1.3,0,2.4,1,2.4,2.6C61.3,27.6,60.2,28.7,58.9,28.7z M47.9,23.2V25h4.3c-0.1,1-0.5,1.8-1,2.3c-0.6,0.6-1.6,1.3-3.3,1.3 c-2.7,0-4.7-2.1-4.7-4.8s2.1-4.8,4.7-4.8c1.4,0,2.5,0.6,3.3,1.3l1.3-1.3c-1.1-1-2.5-1.8-4.5-1.8c-3.6,0-6.7,3-6.7,6.6 s3.1,6.6,6.7,6.6c2,0,3.4-0.6,4.6-1.9c1.2-1.2,1.6-2.9,1.6-4.2c0-0.4,0-0.8-0.1-1.1C54.1,23.2,47.9,23.2,47.9,23.2z M93.2,24.6 c-0.4-1-1.4-2.7-3.6-2.7s-4,1.7-4,4.3c0,2.4,1.8,4.3,4.2,4.3c1.9,0,3.1-1.2,3.5-1.9l-1.4-1c-0.5,0.7-1.1,1.2-2.1,1.2 s-1.6-0.4-2.1-1.3l5.7-2.4L93.2,24.6z M87.4,26c0-1.6,1.3-2.5,2.2-2.5c0.7,0,1.4,0.4,1.6,0.9L87.4,26z M82.8,30.1h1.9V17.6h-1.9 V30.1z M79.7,22.8L79.7,22.8c-0.5-0.5-1.3-1-2.3-1c-2.1,0-4.1,1.9-4.1,4.3s1.9,4.2,4.1,4.2c1,0,1.8-0.5,2.2-1h0.1V30 c0,1.6-0.9,2.5-2.3,2.5c-1.1,0-1.9-0.8-2.1-1.5l-1.6,0.7c0.5,1.1,1.7,2.5,3.8,2.5c2.2,0,4-1.3,4-4.4v-7.6h-1.8 C79.7,22.2,79.7,22.8,79.7,22.8z M77.5,28.7c-1.3,0-2.4-1.1-2.4-2.6s1.1-2.6,2.4-2.6s2.3,1.1,2.3,2.6S78.8,28.7,77.5,28.7z  M101.9,17.6h-4.5v12.5h1.9v-4.7h2.6c2.1,0,4.1-1.5,4.1-3.9S104,17.6,101.9,17.6z M102,23.6h-2.7v-4.3h2.7c1.4,0,2.2,1.2,2.2,2.1 C104.2,22.5,103.4,23.6,102,23.6z M113.5,21.9c-1.4,0-2.8,0.6-3.3,1.9l1.7,0.7c0.4-0.7,1-0.9,1.7-0.9c1,0,1.9,0.6,2,1.6v0.1 c-0.3-0.2-1.1-0.5-1.9-0.5c-1.8,0-3.6,1-3.6,2.8c0,1.7,1.5,2.8,3.1,2.8c1.3,0,1.9-0.6,2.4-1.2h0.1v1h1.8v-4.8 C117.3,23.1,115.6,21.9,113.5,21.9z M113.3,28.7c-0.6,0-1.5-0.3-1.5-1.1c0-1,1.1-1.3,2-1.3c0.8,0,1.2,0.2,1.7,0.4 C115.4,27.9,114.4,28.7,113.3,28.7z M123.9,22.1l-2.1,5.4h-0.1l-2.2-5.4h-2l3.3,7.6l-1.9,4.2h1.9l5.1-11.8 C125.9,22.1,123.9,22.1,123.9,22.1z M107.1,30.1h1.9V17.6h-1.9V30.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 21.97,
    y1: 906.6302,
    x2: 5.1876,
    y2: 923.4126,
    gradientTransform: "matrix(1 0 0 1 0 -897.7502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.6,7.7c-0.3,0.3-0.5,0.8-0.5,1.4v22.1c0,0.6,0.2,1.1,0.5,1.4l0.1,0.1L23,20.3v-0.1V20L10.6,7.7L10.6,7.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.9593,
    y1: 917.9002,
    x2: 9.7624,
    y2: 917.9002,
    gradientTransform: "matrix(1 0 0 1 0 -897.7502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.2,24.4L23,20.3v-0.1V20l4.1-4.1l0.1,0.1l4.9,2.8c1.4,0.8,1.4,2.1,0,2.9L27.2,24.4L27.2,24.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9154,
    y1: 920.1348,
    x2: 2.1571,
    y2: 942.8931,
    gradientTransform: "matrix(1 0 0 1 0 -897.7502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.2,24.3L23,20.1L10.6,32.6c0.5,0.5,1.2,0.5,2.1,0.1L27.2,24.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.3866,
    y1: 898.0869,
    x2: 17.5492,
    y2: 908.2494,
    gradientTransform: "matrix(1 0 0 1 0 -897.7502)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M27.2,15.9L12.6,7.6c-0.9-0.5-1.6-0.4-2.1,0.1L23,20.1L27.2,15.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M27.2,24.3l-14.5,8.2c-0.8,0.5-1.5,0.4-2,0l0,0l-0.1,0.1l0,0l0.1,0.1l0,0c0.5,0.4,1.2,0.5,2,0L27.2,24.3 L27.2,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M10.6,32.4c-0.3-0.3-0.5-0.8-0.5-1.4v0.1c0,0.6,0.2,1.1,0.5,1.4V32.4L10.6,32.4z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M32.1,21.4l-5,2.8l0.1,0.1l4.9-2.8c0.7-0.4,1-0.9,1-1.4l0,0C33.1,20.6,32.8,21.1,32.1,21.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.6,7.7l19.5,11.1c0.6,0.4,1,0.8,1,1.3l0,0c0-0.5-0.3-1-1-1.4L12.6,7.7c-1.4-0.9-2.5-0.2-2.5,1.4v0.1 C10.1,7.6,11.2,7,12.6,7.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M41.4,13.1v-6h1.8c0.9,0,1.7,0.3,2.2,0.8c0.6,0.6,0.8,1.3,0.8,2.2s-0.3,1.6-0.8,2.2c-0.6,0.6-1.3,0.8-2.2,0.8 H41.4z M42.2,12.4h1.1c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-1,0.6-1.7s-0.2-1.3-0.6-1.7c-0.4-0.4-1-0.6-1.6-0.6h-1.1V12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M47.4,13.1v-6h0.8v6H47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M51.2,13.3c-0.4,0-0.9-0.1-1.3-0.4c-0.4-0.3-0.7-0.7-0.8-1.2l0.7-0.3c0.1,0.3,0.3,0.6,0.5,0.8 c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.6-0.1,0.9-0.3c0.2-0.2,0.4-0.4,0.4-0.7s-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.4-1.1-0.5 c-0.5-0.2-0.9-0.4-1.2-0.6c-0.3-0.3-0.4-0.6-0.4-1s0.2-0.8,0.5-1.1C50.2,7.2,50.6,7,51.2,7c0.5,0,0.9,0.1,1.2,0.4s0.5,0.5,0.6,0.8 l-0.7,0.3c-0.1-0.2-0.2-0.4-0.4-0.5c-0.2-0.2-0.5-0.2-0.8-0.2S50.6,7.9,50.3,8C50.1,8.2,50,8.4,50,8.6c0,0.2,0.1,0.4,0.3,0.6 c0.2,0.2,0.5,0.3,0.9,0.4c0.3,0.1,0.5,0.2,0.7,0.3s0.4,0.2,0.6,0.4c0.2,0.1,0.4,0.3,0.5,0.6c0.1,0.2,0.2,0.5,0.2,0.8 s-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.5s-0.4,0.2-0.6,0.3C51.7,13.2,51.4,13.3,51.2,13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M55.1,13.1h-0.8v-6h2c0.5,0,0.9,0.2,1.3,0.5C58,8,58.2,8.4,58.2,8.9s-0.2,0.9-0.6,1.3 c-0.4,0.3-0.8,0.5-1.3,0.5H55L55.1,13.1L55.1,13.1z M55.1,10h1.3c0.3,0,0.6-0.1,0.8-0.3s0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7 C57,8,56.7,7.9,56.4,7.9h-1.3C55.1,7.9,55.1,10,55.1,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M64.1,12.3c-0.6,0.6-1.3,0.9-2.2,0.9s-1.6-0.3-2.2-0.9c-0.6-0.6-0.9-1.3-0.9-2.2s0.3-1.6,0.9-2.2 C60.3,7.3,61,7,61.9,7s1.6,0.3,2.2,0.9S65,9.2,65,10.1C65,11,64.7,11.7,64.1,12.3z M60.3,11.8c0.4,0.4,1,0.7,1.6,0.7 s1.2-0.2,1.6-0.7c0.4-0.4,0.7-1,0.7-1.7S64,8.9,63.5,8.4c-0.4-0.4-1-0.7-1.6-0.7s-1.2,0.2-1.6,0.7c-0.4,0.4-0.7,1-0.7,1.7 S59.8,11.4,60.3,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M66.1,13.1v-6H67l2.9,4.7l0,0v-1.2V7.1h0.8v6h-0.8l-3.1-4.9l0,0v1.2v3.7H66.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M72.1,13.1v-6h0.8v6H72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M74.2,13.1v-6h2.2c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2c0,0.3-0.1,0.5-0.2,0.8 c-0.1,0.2-0.3,0.4-0.6,0.5l0,0c0.3,0.1,0.5,0.3,0.7,0.5s0.3,0.5,0.3,0.9c0,0.5-0.2,0.9-0.5,1.2c-0.4,0.3-0.8,0.5-1.3,0.5L74.2,13.1 L74.2,13.1z M75,9.7h1.4c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.6s-0.1-0.4-0.3-0.6c-0.2-0.2-0.4-0.3-0.7-0.3H75V9.7z M75,12.4h1.6 c0.3,0,0.5-0.1,0.7-0.3s0.3-0.4,0.3-0.7c0-0.2-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3H75V12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M79.4,13.1v-6h0.8v5.3h2.6v0.7H79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M87.2,7.9h-2.7v1.9H87v0.7h-2.5v1.9h2.7v0.7h-3.5v-6h3.5V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M93.9,7.9h-2.7v1.9h2.5v0.7h-2.5v1.9h2.7v0.7h-3.5v-6h3.5V7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M95.1,13.1v-6H96l2.9,4.7l0,0v-1.2V7.1h0.8v6H99l-3.1-4.9l0,0v1.2v3.7H95.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPlaystoreBtnBlack);
export default __webpack_public_path__ + "static/media/download_playstore_btn-black.656314eb22db00826b7187db123d33ef.svg";
export { ForwardRef as ReactComponent };